import { FC } from 'react';
import { Typography } from '@mui/material';

const HouseholdCompositionEmptyState: FC = () => {
  return (
    <Typography variant="body2" color="text.secondary">
      No household members to display.
    </Typography>
  );
};

export default HouseholdCompositionEmptyState;
